<mat-card appearance="outlined" class="step-card">
  <mat-card-content>
    <div class="container">
      <!-- Commenting out this code as we are not going to release it now, but it will be released in the future. -->

      <!-- Left container for "Slide out" -->
      <!--
      <div class="left-container">
        <mat-radio-group class="radio-group" (change)="onRadioChange($event)">
          <mat-radio-button
            value="slideout"
            class="radio-option slideout-radio"
            [checked]="selectedWidgetType === 'slideout'"
            >
            <span class="radio-text">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.SLIDE_OUT_TITLE' | translate }}</span>
          </mat-radio-button>

          <div class="content-box">
            <p class="option-explanation">
              {{
              'MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.SLIDE_OUT_EXPLANATION'
              | translate: { eventType: meetingTypeId }
              }}
            </p>
            <img src="{{ slideOutImage }}" alt="Slide Out Example" class="content-image" />
          </div>
        </mat-radio-group>
      </div>
      -->
      <!-- Right container for "Inline Embed" -->
      <div class="right-container">
        <div class="radio-option inline-radio">
          <span class="radio-text">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.INLINE_TITLE' | translate }}
          </span>
        </div>

        <!-- Content for "Inline Embed" below the radio button -->
        <div class="content-box">
          <p class="option-explanation" [glxyTooltip]="name.length > 40 ? name : null">
            {{
            'MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.INLINE_EXPLANATION'
            | translate: { eventType: name.length > 40 ? (name | slice: 0 : 30) + '...' : name }
            }}
          </p>
          <img src="{{ inlineImage }}" class="content-image" />
        </div>
      </div>
    </div>

    <!-- Common Content Below for Both Options -->
    <div class="embed-code-section">
      <p class="copy-explanation" [glxyTooltip]="name.length > 40 ? name : null">
        {{
        'MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.COPY_PASTE_EXPLANATION'
        | translate: { eventType: name.length > 30 ? (name | slice: 0 : 30) + '...' : name }
        }}
      </p>
      <div class="field">
        <glxy-form-field>
          <textarea matInput readonly class="code-text" rows="7" [value]="widgetEmbedCode"> </textarea>
        </glxy-form-field>
      </div>

      <div class="copy-button">
        @if (isUpdate) {
          <button
            mat-flat-button
            color="primary"
            [cdkCopyToClipboard]="widgetEmbedCode"
            (click)="handleCopyEmbedCodeClicked()"
            >
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.EMBED_CODE_SECTION.COPY_BUTTON_TEXT' | translate }}
          </button>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
